import type React from "react";

interface Tab {
  id: string;
  label: string;
}

export interface NavigationTabProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (tabId: string) => void;
  className?: string;
}

export const NavigationTab: React.FC<NavigationTabProps> = ({
  tabs,
  activeTab,
  onChange,
  className = "",
}) => {
  const handleKeyDown = (e: React.KeyboardEvent, currentTabId: string) => {
    const tabIds = tabs.map((t) => t.id);
    const currentIndex = tabIds.indexOf(currentTabId);

    let nextIndex = currentIndex;

    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      nextIndex = (currentIndex + 1) % tabIds.length;
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      nextIndex = (currentIndex - 1 + tabIds.length) % tabIds.length;
    }

    const nextTabId = tabIds[nextIndex];
    if (nextIndex !== currentIndex && nextTabId !== undefined) {
      e.preventDefault();
      onChange(nextTabId);
    }
  };
  return (
    <div className={`flex gap-6 ${className}`} role="tablist" aria-label="Content filter tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          tabIndex={activeTab === tab.id ? 0 : -1}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          aria-controls={`tabpanel-${tab.id}`}
          id={`tab-${tab.id}`}
          onClick={() => onChange(tab.id)}
          onKeyDown={(e) => handleKeyDown(e, tab.id)}
          className={`pb-3 px-1 label transition-colors ${activeTab === tab.id ? "text-primary-500 border-b-2 border-primary-600" : "text-gray-500 dark:text-gray-400 hover:text-gray-800"}`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
